module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"archive":"Archive","unarchive":"Unarchive","edit":"Edit","flagged":"Flagged","replace":"Replace","save":"Save"}}')
  delete Component.options._Ctor
}
